import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { Typography } from '@material-ui/core'

import {
  Button,
  DialogConfirm,
} from 'ui/components'

import {
  postUserDefineDefaultPlan,
} from 'services/apiMotorBgc'
import { PANEL_ENVS } from 'utils/constants/environments'
import { fetchUser } from 'redux/user/actions'

import styles from './styles'

export default ({ docType, plan, onSubmit = null }) => {
  const classes = styles()
  const dispatch = useDispatch()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const handleCancel = () => {
    setModalOpen(false)
  }

  const handlePlanDelete = async () => {
    setLoading(true)

    const data = {}
    switch (docType) {
      case PANEL_ENVS.CPF:
        data.defaultPlanCpfId = plan.plan_id
        break
      case PANEL_ENVS.CNPJ:
        data.defaultPlanCnpjId = plan.plan_id
        break
      default:
        break
    }

    try {
      await postUserDefineDefaultPlan(
        apiKey,
        userId,
        data,
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao definir plano padrão'
      toast.error(messageError)
      setLoading(false)
      return
    }

    setLoading(false)
    setModalOpen(false)
    toast.success('Plano padrão definido com sucesso!')

    dispatch(fetchUser())
    if (_.isFunction(onSubmit)) onSubmit()
  }

  const renderPlanName = () => {
    return (
      <Typography>
        <strong>Nome:</strong>
        {' '}
        <span>{plan.name}</span>
      </Typography>
    )
  }

  const renderText = () => {
    return (
      <Typography>
        Define como plano padrão do meu usuário?
      </Typography>
    )
  }

  const renderContent = () => {
    if (_.isEmpty(plan)) return null

    return (
      <div className={classes.contentContainer}>
        {renderPlanName()}
        {renderText()}
      </div>
    )
  }

  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        onClick={handleToggleModal}
      >
        Plano padrão
      </Button>

      <DialogConfirm
        title="Plano Padrão"
        open={modalOpen}
        onCancel={handleCancel}
        onConfirm={handlePlanDelete}
        content={renderContent()}
        btnConfirmDisabled={loading}
        btnConfirmText="Confirmar"
        btnCancelText="Cancelar"
      />
    </div>
  )
}
